import React from "react";

import ContactPerson from "./../../images/caseStudy/quotes-img.svg";

export default function HeroSection(props) {
  return (
    <div className="relative max-w-7xl mx-auto overflow-hidden heroSection">
      <div className="absolute inset-y-0 h-full w-full" aria-hidden="true">
        <div className="relative h-full">
          <svg className="absolute left-full transform -translate-y-3/4 -translate-x-1/4 sm:-translate-x-1/2 md:-translate-y-1/2 lg:-translate-x-3/4" width={404} height={784} fill="none" viewBox="0 0 404 784">
            <defs>
              <pattern id="d2a68204-c383-44b1-b99f-42ccff4e5365" x={0} y={0} width={20} height={20} patternUnits="userSpaceOnUse">
                <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect width={404} height={784} fill="url(#d2a68204-c383-44b1-b99f-42ccff4e5365)" />
          </svg>
        </div>
      </div>

      {/* Main Section */}
      <div className="relative pt-0 md:pt-6 pb-8 md:pb-16 px-5 md:px-0 ">
        <main className="mt-12 md:mt-10">
          <div className="mx-auto max-w-7xl">
            <div className="lg:grid lg:grid-cols-12 lg:gap-2">
              <div className="sm:px-6 md:px-0 md:max-w-2xl md:mx-auto lg:col-span-6 sm:text-center lg:text-left lg:flex lg:items-center">
                <div className="break-words text-gray-800 text-center md:text-left">
                  <p className="mt-3 mb-2 text-base text-secondary-700 sm:mt-5 sm:text-xl lg:text-xl xl:text-xl font-bold">
                    {props.case.industry} - {props.case.niche}
                  </p>
                  <div>
                    <span className="mt-1 font-semibold md:leading-loose md:font-semibold text-3xl lg:text-4xl">{props.case.title}</span>
                  </div>
                  <p className={`mt-6 lg:mt-6 mb-6 lg:mb-0 text-base text-gray-600 sm:mt-5 sm:text-xl lg:text-base xl:text-base pr-0 md:pr-12`}>{props.case.description}</p>

                  {/* Desktop - Download Case Study Button */}
                  {/* <div className="mt-10">
                    <button type="button" className="items-center border-2 border-primary-600 rounded-lg bg-white px-6 py-2 text-base font-medium text-primary-600 focus:outline-none focus:ring-0  hover:bg-primary-600 hover:text-white">
                      Download Case Study
                    </button>
                  </div> */}
                </div>
              </div>

              <div className="mt-4 px-2 md:px-5 md:mt-16 lg:mt-0 lg:col-span-6" style={{ "z-index": 9000 }}>
                <img className="rounded-lg shadow border" src={props.case.image}></img>
              </div>
            </div>
          </div>
        </main>
      </div>
      {/* Results Acheived
      <div className="grid grid-cols-3 gap-6 mb-10 rounded-lg">
        {props.case.keyResults.map((keyResult, index) => {
          return (
            <div className="rounded-lg py-7 px-5 text-white text-center bg-gradient-to-r from-pink-500 to-purple-500">
              <div className="text-6xl font-semibold">{keyResult.number}</div>
              <div className="mt-4 text-2xl font-semibold">{keyResult.title}</div>
            </div>
          );
        })}
      </div> */}

      {/* Short Description */}
      <div>
        {/* Desktop */}
        <div className="mt-10 px-5 pt-10 pb-7 hidden md:flex" style={{ background: "#e5f1f6", "border-radius": "30px" }}>
          <div className="flex-none w-96 p-4">
            <img className="h-14" src={props.case.logo} alt="Workcation" />
            <div className="font-bold mt-2">About {props.case.company}</div>
            <div className="leading-7 mt-2 pr-4 text-base">{props.case.about}</div>
          </div>
          <div className="flex-grow p-4 pl-10">
            <div className="mx-auto text-3xl font-medium leading-10 text-primary-800">
              <img className="inline" src={ContactPerson} />
              <div className="mt-2">{props.case.testimonial.description}&rdquo;</div>
            </div>
            <footer className="mt-6">
              <div className="md:flex">
                <div className="md:flex-shrink-0">
                  <img className="mx-auto h-10 w-10 rounded-full" src={props.case.testimonial.image} />
                </div>
                <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                  <div className="text-base font-medium text-gray-900">{props.case.testimonial.name}</div>

                  <svg className="mx-1 hidden h-5 w-5 text-primary-600 md:block" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M11 0h3L9 20H6l5-20z" />
                  </svg>

                  <div className="text-base font-medium text-gray-500">{props.case.testimonial.designation}</div>
                </div>
              </div>
            </footer>
          </div>
        </div>
        {/* Mobile */}
        <div className="sm:block md:hidden mx-4 mt-8" style={{ background: "#e5f1f6", "border-radius": "30px" }}>
          <div className="flex-none w-96 px-6 p-6">
            <img className="h-14" src={props.case.logo} alt="Workcation" />
            <div className="font-bold mt-4">About {props.case.company}</div>
            <div className="leading-7 pr-4 text-base">{props.case.about}</div>
          </div>
          <div className="flex-grow px-6 pb-6">
            <div className="mx-auto text-xl font-medium leading-8 text-primary-800">
              <img className="inline h-8" src={ContactPerson} />
              <div className="mt-2">{props.case.testimonial.description}&rdquo;</div>
            </div>
            <footer className="mt-8">
              <div className="md:flex">
                <div className="md:flex-shrink-0">
                  <img className="mx-auto h-10 w-10 rounded-full" src={props.case.testimonial.image} />
                </div>
                <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                  <div className="text-base font-medium text-gray-900">{props.case.testimonial.name}</div>

                  <svg className="mx-1 hidden h-5 w-5 text-primary-600 md:block" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M11 0h3L9 20H6l5-20z" />
                  </svg>

                  <div className="text-base font-medium text-gray-500">{props.case.testimonial.designation}</div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>

      {/* Challlenge */}
      <div className="rounded-lg mt-16 mx-4 md:mx-0">
        <h2 className="text-left text-5xl font-bold tracking-tight text-primary-900">Challenges</h2>
        <div className="mt-3 text-base md:text-xl text-gray-600">{props.case.study.challenge.description}</div>
        <div className="mt-8">
          {props.case.study.challenge.list.map((challenge) => {
            return (
              <div className="flex mt-4">
                <div className="w-8 pr-2 md:pr-0">
                  <i className="fa-duotone fa-arrow-right"></i>
                </div>
                <div className="flex-grow">
                  <dt className="text-base md:text-xl font-medium leading-6 text-gray-900">{challenge.title}</dt>
                  <dd className="mt-0 text-sm md:text-base text-gray-500">{challenge.description}</dd>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Solution */}
      <div className="rounded-lg my-14 mx-4 md:mx-0">
        {/* Header Description */}
        <h2 className="text-left text-5xl font-bold tracking-tight text-primary-900">Solution</h2>

        {/* Header Description */}
        {props.case.study.challenge.list.map((challenge) => {
          <div className="mt-2 text-lg text-gray-500">{props.case.study.solution.description}</div>;
        })}

        {/* List */}
        <div className="mt-4">
          {props.case.study.solution.map((sol) => {
            return <div className="flex mt-4 text-base md:text-lg text-gray-900">{sol}</div>;
          })}
        </div>
      </div>

      {/* Download Button */}
      {/* <div className="text-center mb-10">
        <button type="button" className="inline-flex items-center rounded-lg border border-transparent px-8 py-3 text-2xl text-white font-semibold focus:outline-none focus:ring-0 " style={{ background: "#01b969" }}>
          Download Case Study
        </button>
      </div> */}
    </div>
  );
}
